import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'
import { DotcEnums } from 'src/common/contracts/enums/dotc'
import useConfig from 'src/config/hooks/useConfig'
import useApproveToken from '../../token/useApproveToken'
import { TakeMultipleOffersParams } from './types'
import useTakeOffer from './useTakeOffer'

const useTakeMultipleOffers = () => {
  // Configuration setup
  const config = useConfig()
  const { smartAccountInfo } = useSmartAccount()

  // Token and Offer functions
  const { takeOfferFixed, takeOfferDynamic } = useTakeOffer()

  const approveToken = useApproveToken()

  // Function to batch transactions
  const takeMultipleOffers = ({
    assetToSell,
    assetToBuy,
    amountToPay,
    orders,
  }: TakeMultipleOffersParams) => {

    if (
      !smartAccountInfo?.address ||
      assetToSell?.type !== 'ERC20' ||
      !assetToBuy
    )
      return

    // Approve token to DotcContract
    const approveTokenTx = approveToken({
      spender: config.contractsAddresses.dotcContractAddress,
      tokenAddress: assetToSell?.contractAddress,
      tokenType: assetToSell?.type,
      amount: amountToPay,
    })

    // Build the multi "takeOffer" transactions
    const takeOffersTxs = orders.map(order => {
      if (order.offerPricingType === DotcEnums.OfferPricingType.FixedPricing) {
        return takeOfferFixed({
          offerId: order.offerId,
          withdrawalAmountPaid: order.amountPaid,
          decimals: assetToSell.decimals,
          affiliate: '',
        })
      } else {
        return takeOfferDynamic({
          offerId: order.offerId,
          withdrawalAmountPaid: order.amountPaid,
          maximumDepositToWithdrawalRate:
            order.maximumDepositToWithdrawalRate || 0n,
          decimals: assetToSell.decimals,
          affiliate: '',
        })
      }
    })


    const transactionsBatch = [
      approveTokenTx,
      ...takeOffersTxs,
    ]

    return transactionsBatch
  }

  return takeMultipleOffers
}

export default useTakeMultipleOffers
